const api4 = 'https://api4.wargos.cloud'
const api5 = 'https://api5.wargos.cloud'
export const Apis = Object.freeze({
  OAUTH: 'https://accounts.wargos.cloud',
  BASE: api4,
  CAPP: `${api5}/xcustomerapp`,
  SORTEOS: `${api4}/xsorteos`,
  PC: `${api4}/xpointcore`,
});
